<template>
  <div>
    <h5>Risk & Suitability</h5>
    <b-row class="mt-7 align-items-stretch">
      <b-col md="4" class="mb-4">
        <b-card
          class="text-center h-100 d-flex align-items-center justify-content-center"
        >
          <img class="riskometer-img" :src="riskometerImage" alt="Riskometer" />
        </b-card>
      </b-col>

      <b-col md="8" class="mb-4">
        <b-card class="h-100 px-4">
          <h5>Suitability</h5>
          <p>
            {{ schemeRiskText }}
          </p>
          <taxAtion />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import taxAtion from './taxAtion.vue'

const store = useStore()
const schemeRisk = computed(
  () => store.getters.schemeData?.schemedetails?.schemeRisk || ''
)
const schemeRiskText = computed(
  () => store.getters.schemeData?.schemedetails?.suitability_text || ''
)
const riskometerMap = {
  'Low to Moderate':
    'https://primeinvestor.in/wp-content/uploads/2021/09/riskometer-low-to-moderate.jpg',
  Low: 'https://primeinvestor.in/wp-content/uploads/2021/09/riskometer-low.jpg',
  'Very High':
    'https://primeinvestor.in/wp-content/uploads/2021/09/riskometer-very-high.jpg',
  Moderate:
    'https://primeinvestor.in/wp-content/uploads/2021/09/riskometer-moderate.jpg',
  'Moderately High':
    'https://primeinvestor.in/wp-content/uploads/2021/09/riskometer-moderate-high.jpg',
  High: 'https://primeinvestor.in/wp-content/uploads/2021/09/riskometer-high.jpg',
}

const riskometerImage = computed(() => riskometerMap[schemeRisk.value] || '')
</script>
<style scoped>
.riskometer-img {
  width: 100%;
  max-width: 250px;
  height: auto;
}
</style>
